import { useQuery } from "react-query";
import { fetchHouseMeasuresData } from "./api";

export function useHouseMeasures(filters, options = {}) {
  return useQuery(
    ["fetchHouseMeasuresData", filters],
    () => fetchHouseMeasuresData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 600,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
